import { ModuleType } from '@/types/router'

const myAccountRoute: ModuleType = {
  moduleKey: 'myAccountAllData',
  title: '我的账户',
  icon: 'money',
  router: [
    {
      title: '我的资产',
      name: 'myAssetsModule',
      path: '/myAssets',
      component: () => import('@/views/layout/index.vue'),
      children: [
        {
          path: 'positionDetails',
          component: () => import('@/views/myAccount/positionDetails.vue'),
          name: 'myAssetsrPositionDetails',
          meta: { title: '持仓明细', icon: 'trend', pageId: '3' }
        }
      ]
    },
    {
      title: '交易中心',
      name: 'transCenterModule',
      path: '/transCenter',
      component: () => import('@/views/layout/index.vue'),
      children: [
        {
          path: 'todoList',
          component: () => import('@/views/myAccount/todoList.vue'),
          name: 'todoList',
          meta: { title: '待办事项', icon: 'todoList', pageId: '47' }
        },
        {
          path: 'placeOrder',
          component: () => import('@/components/index.vue'),
          name: 'transCenterplaceOrder',
          redirect: '/transCenter/placeOrder/singleOrder/purchase',
          meta: { title: '交易下单', icon: 'order', pageId: '14' },
          children: [
            {
              path: 'singleOrder',
              component: () => import('@/components/index.vue'),
              name: 'singleOrder',
              redirect: '/transCenter/placeOrder/singleOrder/purchase',
              meta: { title: '单笔下单', pageId: '14', menuShow: true },
              children: [
                {
                  path: 'purchase',
                  component: () => import('@/views/myAccount/purchaseProduct.vue'),
                  name: 'myAssetsOrderPurchase',
                  meta: { title: '产品买入', pageId: '14' }
                },
                {
                  path: 'sales',
                  component: () => import('@/views/myAccount/productSales.vue'),
                  name: 'myAssetsOrderSales',
                  meta: { title: '产品卖出', pageId: '14' }
                },
                {
                  path: 'conversion',
                  component: () => import('@/views/myAccount/productConversion.vue'),
                  name: 'myAssetsOrderConversion',
                  meta: { title: '产品转换', pageId: '14' }
                },
                {
                  path: 'orderInfoConfirm',
                  name: 'myAssetsSmOrderInfoConfirm',
                  hide: true,
                  component: () => import('@/views/myAccount/purchase/orderInfoConfirm.vue'),
                  meta: { title: '产品买入', pageId: '14' }
                }
              ]
            },
            {
              path: 'batchOrder',
              component: () => import('@/components/index.vue'),
              name: 'batchOrder',
              redirect: '/transCenter/placeOrder/batchOrder/purchase',
              meta: { title: '批量下单', pageId: '14', menuShow: true },
              children: [
                {
                  path: 'purchase',
                  component: () => import('@/views/myAccount/batchOrder/index.vue'),
                  name: 'myAssetsBatchOrderPurchase',
                  meta: { title: '产品买入', pageId: '14' }
                },
                {
                  path: 'batchSales',
                  component: () => import('@/views/myAccount/batchOrder/batchSales.vue'),
                  name: 'myAssetsBatchSales',
                  meta: { title: '产品卖出', pageId: '14' }
                },
                {
                  path: 'batchChange',
                  component: () => import('@/views/myAccount/batchOrder/batchChange.vue'),
                  name: 'myAssetsBatchChange',
                  meta: { title: '产品转换', pageId: '14' }
                }
              ]
            }
          ]
        },
        {
          path: 'transaction',
          component: () => import('@/components/index.vue'),
          name: 'transCenterTransactionIndex',
          redirect: '/transCenter/transaction/index',
          meta: { title: '交易记录', icon: 'record', pageId: '37' },
          children: [
            {
              path: 'index',
              name: 'transCenterTransaction',
              component: () => import('@/views/myAccount/transaction.vue'),
              meta: { title: '交易记录', pageId: '37' }
            },
            {
              path: 'cancel',
              name: 'transCenterCancel',
              component: () => import('@/views/myAccount/batchCancel.vue'),
              meta: { title: '批量撤单', pageId: '37' }
            }
          ]
        },
        {
          path: 'dividendQuery',
          component: () => import('@/views/myAccount/dividendQuery.vue'),
          name: 'transCenterDividendQuery',
          meta: { title: '分红查询', icon: 'bonus', pageId: '46' }
        },
        {
          path: 'contractOrder',
          component: () => import('@/views/myAccount/contractOrder.vue'),
          name: 'transCenterContractOrder',
          meta: { title: '电子合同订单', icon: 'contractOrder', pageId: '59' }
        }
      ]
    },
    {
      title: '系统管理',
      name: 'systemManageModule',
      path: '/systemManage',
      component: () => import('@/views/layout/index.vue'),
      children: [
        {
          path: 'hgtzzDetail',
          component: () => import('@/views/systemManage/hgtzzDetail.vue'),
          name: 'hgtzzDetail',
          meta: { title: '合格投资者认证', icon: 'hgtzzDetail', pageId: '66' }
        },
        {
          path: 'investmentAccount',
          component: () => import('@/components/index.vue'),
          name: 'systemInvestmentAccount',
          meta: { title: '投资账户', icon: 'account' },
          redirect: '/systemManage/investmentAccount/inveAccount',
          children: [
            {
              path: 'inveAccount',
              component: () => import('@/views/systemManage/inveAccount.vue'),
              name: 'inveAccount',
              meta: { title: '投资账户', pageId: '69' }
            },
            {
              path: 'accountDetail',
              component: () => import('@/views/systemManage/accountDetail.vue'),
              name: 'accountDetail',
              meta: { title: '账户详情', pageId: '69' }
            },
            {
              path: 'jghDetail',
              component: () => import('@/views/systemManage/jghDetail.vue'),
              name: 'jghDetail',
              meta: { title: '投资账户信息', pageId: '69' }
            },
            {
              path: 'fundAccount',
              component: () => import('@/views/systemManage/fundAccount.vue'),
              name: 'fundAccount',
              meta: { title: '基金账户', pageId: '69' }
            },
            {
              path: 'expiredFiles',
              component: () => import('@/views/systemManage/expiredFiles.vue'),
              name: 'accountExpiredFiles',
              meta: { title: '账户过期', pageId: '69' }
            }
          ]
        },
        {
          path: 'userManagement',
          component: () => import('@/components/index.vue'),
          name: 'userManagement',
          redirect: '/systemManage/userManagement/index',
          meta: { title: '用户管理', icon: 'userManage' },
          children: [
            {
              path: 'index',
              component: () => import('@/views/systemManage/userManagement.vue'),
              name: 'userManagement',
              meta: { pageId: '98' }
            },
            {
              path: 'detail',
              component: () => import('@/views/systemManage/userManagementDetail.vue'),
              name: 'userManagementDetail',
              meta: { title: '用户权限', pageId: '98' }
            }
          ]
        },
        {
          path: 'roleManage',
          name: 'roleManage',
          component: () => import('@/components/index.vue'),
          meta: { title: '角色管理', icon: 'roleManage' },
          redirect: '/systemManage/roleManage',
          children: [
            {
              path: '',
              name: 'roleManageList',
              component: () => import('@/views/systemManage/roleManagement.vue'),
              meta: { title: '角色管理', pageId: '105' }
            },
            {
              path: 'auth',
              name: 'roleMange:auth',
              component: () => import('@/views/systemManage/roleEdit.vue'),
              meta: { title: '角色权限', pageId: '105' }
            }
          ]
        },
        {
          path: 'log',
          component: () => import('@/views/systemManage/useLog.vue'),
          name: 'log',
          meta: { title: '操作日志', icon: 'dingdanhuorizhi', pageId: '113' }
        },
        {
          path: 'modeSetting',
          component: () => import('@/components/index.vue'),
          name: 'modeSettingIndex',
          redirect: '/systemManage/modeSetting/index',
          meta: { title: '模式设置', icon: 'moduleSet' },
          children: [
            {
              path: 'index',
              component: () => import('@/views/systemManage/modeSetting.vue'),
              name: 'modeSettingIndex',
              meta: { title: '模式设置', pageId: '84' }
            },
            {
              path: 'firstModeSetting',
              component: () => import('@/views/systemManage/firstModeSetting.vue'),
              name: 'firstModeSetting',
              meta: { title: '管理员首次登录提示', pageId: '84' }
            },
            {
              path: 'edit',
              component: () => import('@/views/systemManage/firstModeSetting.vue'),
              name: 'modeSettingEdit',
              meta: { title: '模式设置', pageId: '84' }
            }
          ]
        },
        {
          path: 'mailSubscription',
          name: 'mailSubscription',
          component: () => import('@/components/index.vue'),
          meta: { title: '邮件订阅', icon: 'mailSub' },
          redirect: '/systemManage/mailSubscription/index',
          children: [
            {
              path: 'index',
              name: 'mailSubList',
              component: () => import('@/views/systemManage/mailSubscription.vue'),
              meta: { title: '邮件订阅', pageId: '109' }
            },
            {
              path: 'edit',
              name: 'mailSub:edit',
              component: () => import('@/views/systemManage/mailSubEdit.vue'),
              meta: { title: '添加订阅', pageId: '109' }
            }
          ]
        },
        {
          path: 'infoCopy',
          component: () => import('@/views/systemManage/infoCopy.vue'),
          name: 'infoCopy',
          meta: { title: '账单打印', icon: 'infoCopy', pageId: '110' }
        }
      ]
    },
    {
      title: '个人信息',
      name: 'myAccountModule',
      path: '/myAccount',
      hide: true, // 隐藏菜单
      authenticating: true,
      component: () => import('@/views/layout/index.vue'),
      children: [
        {
          path: 'personalInformation',
          component: () => import('@/views/myAccount/personalInformation.vue'),
          name: 'personalInformation',
          meta: { title: '个人信息', authenticating: true }
        },
        {
          path: 'changePassword',
          component: () => import('@/components/index.vue'),
          name: 'changePassword',
          meta: { title: '修改密码' },
          redirect: '/myAccount/changePassword/changePassword',
          children: [
            {
              path: 'changePassword',
              component: () => import('@/views/myAccount/changePassword.vue'),
              name: 'changePassword'
            },
            {
              path: 'changeSuccess',
              component: () => import('@/views/myAccount/changeSuccess.vue'),
              name: 'changeSuccess'
            }
          ]
        },
        {
          path: 'resetPassword',
          component: () => import('@/components/index.vue'),
          name: 'resetPassword',
          meta: { title: '重置密码' },
          authenticating: true,
          redirect: '/myAccount/resetPassword/resetPassword',
          children: [
            {
              path: 'resetPassword',
              component: () => import('@/views/myAccount/resetPassword.vue'),
              name: 'resetPassword'
            },
            {
              path: 'resetSuccess',
              component: () => import('@/views/myAccount/changeSuccess.vue'),
              name: 'resetSuccess'
            }
          ]
        }
      ]
    }
  ]
}
export { myAccountRoute }
